<template>
  <button
    v-if="isMobile"
    class="icon-btn-close"
    @click="onClose"
    :aria-label="ariaLabel"
  >

  </button>
</template>

<script setup lang="ts">
defineProps<{
  isMobile: boolean;
  onClose: () => void;
  ariaLabel: string;
}>();
</script>

<style scoped>
.icon-btn-close {
  background: transparent !important;
  color: hsl(var(--foreground)) !important;
  border: none !important;
  padding: 0.25rem !important;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.icon-btn-close:hover {
  background: hsl(var(--accent)) !important;
}

.icon-btn-close i {
  font-size: 1.25rem;
}
</style>

